const atcObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const target = entry.target.closest('.product-wrapper').querySelector('.sticky-atc');
      if (target !== null) {
        entry.isIntersecting ? target.classList.remove('active') : target.classList.add('active');
      }
    });
  },
  {
    threshold: 0.25,
  }
);

atcObserver.observe(document.querySelector('#AddToCartButton'));
document.querySelector('.sticky-atc').addEventListener('click', () => {
  document.querySelector('.product-form').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
});

if (document.querySelector('.gallery-zoom')) {
  const zoom_container = document.querySelector('.gallery-zoom');

  document.querySelectorAll('.product__media-item:not(.media-video)').forEach((item) => {
    item.addEventListener('click', function () {
      let img = item.querySelector('img').src.replace('&width=1440', '&width=2048');

      document.body.classList.add('drawer--open');
      zoom_container.classList.add('gallery-zoom--active');
      zoom_container.querySelector('img').src = img;
    });
  });

  zoom_container.addEventListener('click', function () {
    document.body.classList.remove('drawer--open');
    zoom_container.classList.remove('gallery-zoom--active');
  });
}
